import React, { useRef, useState, useEffect } from 'react';
import LetterCanvas from './LetterCanvas';
import { GameHeaderBar } from './GameHeaderBar';

const randonLetters = "ABCDEFGHIJKLMNOPQRSTUVWXYZ".split("");
const letters = [
    {
        image: '/letter-direction/a.png',
        strokes: [
            { start: { x: 150, y: 40 }, end: { x: 90, y: 260 } },
            { start: { x: 150, y: 40 }, end: { x: 210, y: 260 } },
            { start: { x: 110, y: 170 }, end: { x: 190, y: 170 } }
        ]
    },
    {
        image: '/letter-direction/b.png',
        strokes: [
            { start: { x: 90, y: 50 }, end: { x: 90, y: 250 } },
            { start: { x: 90, y: 50 }, end: { x: 160, y: 50 } },
            { start: { x: 160, y: 50 }, end: { x: 190, y: 75 } },
            { start: { x: 190, y: 75 }, end: { x: 190, y: 115 } },
            { start: { x: 190, y: 115 }, end: { x: 160, y: 140 } },
            { start: { x: 160, y: 140 }, end: { x: 90, y: 140 } },
            { start: { x: 90, y: 140 }, end: { x: 160, y: 140 } },
            { start: { x: 160, y: 140 }, end: { x: 190, y: 165 } },
            { start: { x: 190, y: 165 }, end: { x: 190, y: 225 } },
            { start: { x: 190, y: 225 }, end: { x: 160, y: 250 } },
            { start: { x: 160, y: 250 }, end: { x: 90, y: 250 } }
        ]
    },
    {
        image: '/letter-direction/c.png',
        strokes: [
            { start: { x: 200, y: 80 }, end: { x: 170, y: 60 } },
            { start: { x: 170, y: 60 }, end: { x: 130, y: 50 } },
            { start: { x: 130, y: 50 }, end: { x: 100, y: 70 } },
            { start: { x: 100, y: 70 }, end: { x: 90, y: 110 } },
            { start: { x: 90, y: 110 }, end: { x: 90, y: 190 } },
            { start: { x: 90, y: 190 }, end: { x: 100, y: 230 } },
            { start: { x: 100, y: 230 }, end: { x: 130, y: 250 } },
            { start: { x: 130, y: 250 }, end: { x: 170, y: 240 } },
            { start: { x: 170, y: 240 }, end: { x: 200, y: 220 } }
        ]
    },
    {
        image: '/letter-direction/d.png',
        strokes: [
            { start: { x: 90, y: 50 }, end: { x: 90, y: 250 } },
            { start: { x: 90, y: 50 }, end: { x: 150, y: 50 } },
            { start: { x: 150, y: 50 }, end: { x: 190, y: 80 } },
            { start: { x: 190, y: 80 }, end: { x: 210, y: 120 } },
            { start: { x: 210, y: 120 }, end: { x: 210, y: 180 } },
            { start: { x: 210, y: 180 }, end: { x: 190, y: 220 } },
            { start: { x: 190, y: 220 }, end: { x: 150, y: 250 } },
            { start: { x: 150, y: 250 }, end: { x: 90, y: 250 } }
        ]
    },
    {
        image: '/letter-direction/e.png',
        strokes: [
            { start: { x: 90, y: 50 }, end: { x: 90, y: 250 } },
            { start: { x: 90, y: 50 }, end: { x: 210, y: 50 } },
            { start: { x: 90, y: 150 }, end: { x: 180, y: 150 } },
            { start: { x: 90, y: 250 }, end: { x: 210, y: 250 } }
        ]
    },
    {
        image: '/letter-direction/f.png',
        strokes: [
            { start: { x: 90, y: 50 }, end: { x: 90, y: 250 } },
            { start: { x: 90, y: 50 }, end: { x: 210, y: 50 } },
            { start: { x: 90, y: 145 }, end: { x: 180, y: 145 } }
        ]
    },
    {
        image: '/letter-direction/g.png',
        strokes: [
            { start: { x: 200, y: 80 }, end: { x: 170, y: 60 } },
            { start: { x: 170, y: 60 }, end: { x: 130, y: 50 } },
            { start: { x: 130, y: 50 }, end: { x: 100, y: 70 } },
            { start: { x: 100, y: 70 }, end: { x: 90, y: 110 } },
            { start: { x: 90, y: 110 }, end: { x: 90, y: 190 } },
            { start: { x: 90, y: 190 }, end: { x: 100, y: 230 } },
            { start: { x: 100, y: 230 }, end: { x: 130, y: 250 } },
            { start: { x: 130, y: 250 }, end: { x: 170, y: 240 } },
            { start: { x: 170, y: 240 }, end: { x: 200, y: 220 } },
            { start: { x: 200, y: 220 }, end: { x: 210, y: 180 } },
            { start: { x: 210, y: 180 }, end: { x: 210, y: 155 } },
            { start: { x: 210, y: 155 }, end: { x: 150, y: 155 } }
        ]
    },
    {
        image: '/letter-direction/h.png',
        strokes: [
            { start: { x: 90, y: 50 }, end: { x: 90, y: 250 } },
            { start: { x: 90, y: 145 }, end: { x: 210, y: 145 } },
            { start: { x: 210, y: 145 }, end: { x: 210, y: 250 } }
        ]
    },
    {
        image: '/letter-direction/i.png',
        strokes: [
            { start: { x: 130, y: 50 }, end: { x: 170, y: 50 } },
            { start: { x: 150, y: 50 }, end: { x: 150, y: 250 } },
            { start: { x: 130, y: 250 }, end: { x: 170, y: 250 } }
        ]
    },
    {
        image: '/letter-direction/j.png',
        strokes: [
            { start: { x: 190, y: 50 }, end: { x: 190, y: 210 } },
            { start: { x: 190, y: 210 }, end: { x: 150, y: 250 } },
            { start: { x: 150, y: 250 }, end: { x: 110, y: 210 } }
        ]
    },
    {
        image: '/letter-direction/k.png',
        strokes: [
            { start: { x: 90, y: 50 }, end: { x: 90, y: 250 } },
            { start: { x: 210, y: 50 }, end: { x: 90, y: 145 } },
            { start: { x: 90, y: 145 }, end: { x: 210, y: 250 } }
        ]
    },
    {
        image: '/letter-direction/l.png',
        strokes: [
            { start: { x: 90, y: 50 }, end: { x: 90, y: 250 } },
            { start: { x: 90, y: 250 }, end: { x: 210, y: 250 } }
        ]
    },
    {
        image: '/letter-direction/m.png',
        strokes: [
            { start: { x: 80, y: 250 }, end: { x: 80, y: 50 } },
            { start: { x: 80, y: 50 }, end: { x: 150, y: 145 } },
            { start: { x: 150, y: 145 }, end: { x: 220, y: 50 } },
            { start: { x: 220, y: 50 }, end: { x: 220, y: 250 } }
        ]
    },
    {
        image: '/letter-direction/n.png',
        strokes: [
            { start: { x: 90, y: 250 }, end: { x: 90, y: 50 } },
            { start: { x: 90, y: 50 }, end: { x: 210, y: 250 } },
            { start: { x: 210, y: 250 }, end: { x: 210, y: 50 } }
        ]
    },
    {
        image: '/letter-direction/o.png',
        strokes: [
            { start: { x: 150, y: 50 }, end: { x: 110, y: 60 } },
            { start: { x: 110, y: 60 }, end: { x: 90, y: 90 } },
            { start: { x: 90, y: 90 }, end: { x: 90, y: 150 } },
            { start: { x: 90, y: 150 }, end: { x: 90, y: 210 } },
            { start: { x: 90, y: 210 }, end: { x: 110, y: 240 } },
            { start: { x: 110, y: 240 }, end: { x: 150, y: 250 } },
            { start: { x: 150, y: 250 }, end: { x: 190, y: 240 } },
            { start: { x: 190, y: 240 }, end: { x: 210, y: 210 } },
            { start: { x: 210, y: 210 }, end: { x: 210, y: 150 } },
            { start: { x: 210, y: 150 }, end: { x: 210, y: 90 } },
            { start: { x: 210, y: 90 }, end: { x: 190, y: 60 } },
            { start: { x: 190, y: 60 }, end: { x: 150, y: 50 } }
        ]
    },
    {
        image: '/letter-direction/p.png',
        strokes: [
            { start: { x: 90, y: 50 }, end: { x: 90, y: 250 } },
            { start: { x: 90, y: 50 }, end: { x: 160, y: 50 } },
            { start: { x: 160, y: 50 }, end: { x: 190, y: 70 } },
            { start: { x: 190, y: 70 }, end: { x: 210, y: 95 } },
            { start: { x: 210, y: 95 }, end: { x: 190, y: 120 } },
            { start: { x: 190, y: 120 }, end: { x: 160, y: 140 } },
            { start: { x: 160, y: 140 }, end: { x: 90, y: 140 } }
        ]
    },
    {
        image: '/letter-direction/q.png',
        strokes: [
            { start: { x: 150, y: 50 }, end: { x: 110, y: 60 } },
            { start: { x: 110, y: 60 }, end: { x: 90, y: 90 } },
            { start: { x: 90, y: 90 }, end: { x: 90, y: 150 } },
            { start: { x: 90, y: 150 }, end: { x: 90, y: 210 } },
            { start: { x: 90, y: 210 }, end: { x: 110, y: 240 } },
            { start: { x: 110, y: 240 }, end: { x: 150, y: 250 } },
            { start: { x: 150, y: 250 }, end: { x: 190, y: 240 } },
            { start: { x: 190, y: 240 }, end: { x: 210, y: 210 } },
            { start: { x: 210, y: 210 }, end: { x: 210, y: 150 } },
            { start: { x: 210, y: 150 }, end: { x: 210, y: 90 } },
            { start: { x: 210, y: 90 }, end: { x: 190, y: 60 } },
            { start: { x: 190, y: 60 }, end: { x: 150, y: 50 } },
            { start: { x: 165, y: 195 }, end: { x: 220, y: 260 } }
        ]
    },
    {
        image: '/letter-direction/r.png',
        strokes: [
            { start: { x: 90, y: 50 }, end: { x: 90, y: 250 } },
            { start: { x: 90, y: 50 }, end: { x: 160, y: 50 } },
            { start: { x: 160, y: 50 }, end: { x: 190, y: 70 } },
            { start: { x: 190, y: 70 }, end: { x: 210, y: 95 } },
            { start: { x: 210, y: 95 }, end: { x: 190, y: 120 } },
            { start: { x: 190, y: 120 }, end: { x: 160, y: 140 } },
            { start: { x: 160, y: 140 }, end: { x: 90, y: 140 } },
            { start: { x: 90, y: 140 }, end: { x: 210, y: 250 } }
        ]
    },
    {
        image: '/letter-direction/s.png',
        strokes: [
            { start: { x: 200, y: 90 }, end: { x: 170, y: 65 } },
            { start: { x: 170, y: 65 }, end: { x: 130, y: 50 } },
            { start: { x: 130, y: 50 }, end: { x: 100, y: 65 } },
            { start: { x: 100, y: 65 }, end: { x: 90, y: 95 } },
            { start: { x: 90, y: 95 }, end: { x: 110, y: 125 } },
            { start: { x: 110, y: 125 }, end: { x: 150, y: 145 } },
            { start: { x: 150, y: 145 }, end: { x: 190, y: 165 } },
            { start: { x: 190, y: 165 }, end: { x: 210, y: 195 } },
            { start: { x: 210, y: 195 }, end: { x: 200, y: 225 } },
            { start: { x: 200, y: 225 }, end: { x: 170, y: 245 } },
            { start: { x: 170, y: 245 }, end: { x: 130, y: 250 } },
            { start: { x: 130, y: 250 }, end: { x: 100, y: 235 } },
            { start: { x: 100, y: 235 }, end: { x: 90, y: 210 } }
        ]
    },
    {
        image: '/letter-direction/t.png',
        strokes: [
            { start: { x: 90, y: 50 }, end: { x: 210, y: 50 } },
            { start: { x: 150, y: 50 }, end: { x: 150, y: 250 } }
        ]
    },
    {
        image: '/letter-direction/u.png',
        strokes: [
            { start: { x: 90, y: 50 }, end: { x: 90, y: 190 } },
            { start: { x: 90, y: 190 }, end: { x: 100, y: 220 } },
            { start: { x: 100, y: 220 }, end: { x: 130, y: 245 } },
            { start: { x: 130, y: 245 }, end: { x: 170, y: 245 } },
            { start: { x: 170, y: 245 }, end: { x: 200, y: 220 } },
            { start: { x: 200, y: 220 }, end: { x: 210, y: 190 } },
            { start: { x: 210, y: 190 }, end: { x: 210, y: 50 } }
        ]
    },
    {
        image: '/letter-direction/v.png',
        strokes: [
            { start: { x: 90, y: 50 }, end: { x: 150, y: 250 } },
            { start: { x: 150, y: 250 }, end: { x: 210, y: 50 } }
        ]
    },
    {
        image: '/letter-direction/w.png',
        strokes: [
            { start: { x: 80, y: 50 }, end: { x: 105, y: 250 } },
            { start: { x: 105, y: 250 }, end: { x: 150, y: 140 } },
            { start: { x: 150, y: 140 }, end: { x: 195, y: 250 } },
            { start: { x: 195, y: 250 }, end: { x: 220, y: 50 } }
        ]
    },
    {
        image: '/letter-direction/x.png',
        strokes: [
            { start: { x: 90, y: 50 }, end: { x: 210, y: 250 } },
            { start: { x: 210, y: 50 }, end: { x: 90, y: 250 } }
        ]
    },
    {
        image: '/letter-direction/y.png',
        strokes: [
            { start: { x: 90, y: 50 }, end: { x: 150, y: 145 } },
            { start: { x: 210, y: 50 }, end: { x: 150, y: 145 } },
            { start: { x: 150, y: 145 }, end: { x: 150, y: 250 } }
        ]
    },
    {
        image: '/letter-direction/z.png',
        strokes: [
            { start: { x: 90, y: 50 }, end: { x: 210, y: 50 } },
            { start: { x: 210, y: 50 }, end: { x: 90, y: 250 } },
            { start: { x: 90, y: 250 }, end: { x: 210, y: 250 } }
        ]
    },
];

const LetterDrawingComp = ({ type, onComplete }) => {
    const [completed, setCompleted] = useState(false);
    const [score, setScore] = useState(0);
    const [volume, setVolume] = useState(1);
    const [isMuted, setIsMuted] = useState(false);
    const [message, setMessage] = useState('');
    const [index, setIndex] = useState(0);
    const [letterOrder, setLetterOrder] = useState([]);
    const [scoreAnim, setScoreAnim] = useState(false);
    const [letterCompleted, setLetterCompleted] = useState(false);
    const canvasResetRef = useRef(null);

    // For dynamic/random order
    useEffect(() => {
        if (type === "random" || type === "dynamic") {
            const shuffled = [...randonLetters].sort(() => 0.5 - Math.random());
            setLetterOrder(shuffled);
            setIndex(0);
        } else {
            setLetterOrder([...randonLetters]);
            setIndex(0);
        }
    }, [type]);

    // Load volume from local storage
    useEffect(() => {
        const savedVolume = localStorage.getItem('tapGameVolume');
        if (savedVolume !== null) {
            setVolume(parseFloat(savedVolume));
        }
    }, []);

    // Speak the current letter only when moving to a new letter (not when completing)
    useEffect(() => {
        if (!completed && letterOrder.length > 0 && !isMuted && !letterCompleted) {
            const utterance = new SpeechSynthesisUtterance(`Draw letter ${letterOrder[index]}`);
            utterance.rate = 0.9;
            utterance.volume = volume;
            speechSynthesis.speak(utterance);
        }
    }, [index, letterOrder, isMuted, volume]);

    const handleComplete = () => {
        setCompleted(true);
        setLetterCompleted(true);
        const newScore = score + 1;
        setScore(newScore);
        setMessage('🎉 Perfect! Letter completed!');
        setScoreAnim(true);
        setTimeout(() => setScoreAnim(false), 700);
        
        // Speech is already handled in LetterCanvas.js, no need to speak again here

        // Check if this is the last letter
        const isLastLetter = index === letterOrder.length - 1;

        // Auto-advance to next letter after 2 seconds
        setTimeout(() => {
            if (!isLastLetter) {
                setIndex(index + 1);
                setCompleted(false);
                setLetterCompleted(false);
                setMessage('');
                if (canvasResetRef.current) {
                    canvasResetRef.current();
                }
            } else {
                // All letters completed - trigger parent callback to close popup
                setMessage('🎉 All letters completed! Great job!');
                setTimeout(() => {
                    if (onComplete) {
                        onComplete(true, newScore, letterOrder.length);
                    }
                }, 1000);
            }
        }, 2000);
    };

    const handleNext = () => {
        if (index < letterOrder.length - 1) {
            setIndex(index + 1);
            setCompleted(false);
            setLetterCompleted(false);
            setMessage('');
            if (canvasResetRef.current) {
                canvasResetRef.current();
            }
        } else {
            setMessage('🎉 All letters completed! Great job!');
        }
    };

    const handleBack = () => {
        if (index > 0) {
            setIndex(index - 1);
            setCompleted(false);
            setLetterCompleted(false);
            setMessage('');
            if (canvasResetRef.current) {
                canvasResetRef.current();
            }
        }
    };

    const handleRetry = () => {
        setCompleted(false);
        setLetterCompleted(false);
        setMessage('');
        if (canvasResetRef.current) {
            canvasResetRef.current();
        }
    };

    // Get current letter and letter data
    const currentLetter = letterOrder[index];
    const letterIdx = randonLetters.indexOf(currentLetter);

    return (
        <div className="tap-letter-board-bg">
            <GameHeaderBar
              score={score}
              total={letterOrder.length}
              questionLabel="Draw letter:"
              question={currentLetter}
              volume={volume}
              onVolumeChange={(v) => {
                setVolume(v);
                localStorage.setItem('tapGameVolume', v);
              }}
              replayTitle="Replay Letter"
              onReplay={() => {
                if (currentLetter && !isMuted) {
                  const utterance = new window.SpeechSynthesisUtterance(`Draw letter ${currentLetter}`);
                  utterance.rate = 0.9;
                  utterance.volume = volume;
                  window.speechSynthesis.speak(utterance);
                }
              }}
            />
            <div style={{ width: "100%", display: "flex", flexDirection: "column", alignItems: "center" }}>
                <p className={scoreAnim ? 'score-pop' : ''} style={{ fontSize: 18, fontWeight: 500 }}>
                    {/* Score already shown in header */}
                </p>
                {letterIdx !== -1 && (
                    <LetterCanvas
                        key={`${currentLetter}-${index}`}
                        image={letters[letterIdx].image}
                        strokes={letters[letterIdx].strokes}
                        onComplete={handleComplete}
                        completed={completed}
                        onResetRef={(resetFn) => { canvasResetRef.current = resetFn; }}
                    />
                )}
                {message && (
                    <h2 style={{ 
                        margin: '20px 0', 
                        color: letterCompleted ? '#27AE60' : '#E74C3C',
                        fontSize: '1.5rem',
                        fontWeight: 'bold',
                        textAlign: 'center'
                    }}>{message}</h2>
                )}
                
                {/* Navigation Buttons */}
                <div style={{ 
                    display: 'flex', 
                    gap: '12px', 
                    marginTop: '20px',
                    flexWrap: 'wrap',
                    justifyContent: 'center'
                }}>
                    <button
                        onClick={handleBack}
                        disabled={index === 0}
                        style={{
                            padding: '12px 24px',
                            fontSize: '16px',
                            fontWeight: '600',
                            borderRadius: '12px',
                            border: 'none',
                            background: index === 0 ? '#95a5a6' : 'linear-gradient(135deg, #667eea 0%, #764ba2 100%)',
                            color: '#fff',
                            cursor: index === 0 ? 'not-allowed' : 'pointer',
                            boxShadow: index === 0 ? 'none' : '0 4px 12px rgba(102, 126, 234, 0.4)',
                            display: 'flex',
                            alignItems: 'center',
                            gap: '8px',
                            transition: 'all 0.3s ease',
                            opacity: index === 0 ? 0.6 : 1
                        }}
                        onMouseEnter={(e) => {
                            if (index > 0) e.currentTarget.style.transform = 'translateY(-2px)';
                        }}
                        onMouseLeave={(e) => {
                            e.currentTarget.style.transform = 'translateY(0)';
                        }}
                    >
                        <span className="material-symbols-outlined" style={{ fontSize: 20 }}>arrow_back</span>
                        Previous
                    </button>

                    <button
                        onClick={handleRetry}
                        style={{
                            padding: '12px 24px',
                            fontSize: '16px',
                            fontWeight: '600',
                            borderRadius: '12px',
                            border: 'none',
                            background: 'linear-gradient(135deg, #f093fb 0%, #f5576c 100%)',
                            color: '#fff',
                            cursor: 'pointer',
                            boxShadow: '0 4px 12px rgba(240, 147, 251, 0.4)',
                            display: 'flex',
                            alignItems: 'center',
                            gap: '8px',
                            transition: 'all 0.3s ease'
                        }}
                        onMouseEnter={(e) => {
                            e.currentTarget.style.transform = 'translateY(-2px)';
                        }}
                        onMouseLeave={(e) => {
                            e.currentTarget.style.transform = 'translateY(0)';
                        }}
                    >
                        <span className="material-symbols-outlined" style={{ fontSize: 20 }}>refresh</span>
                        Retry
                    </button>

                    <button
                        onClick={handleNext}
                        disabled={!letterCompleted || index >= letterOrder.length - 1}
                        style={{
                            padding: '12px 24px',
                            fontSize: '16px',
                            fontWeight: '600',
                            borderRadius: '12px',
                            border: 'none',
                            background: (!letterCompleted || index >= letterOrder.length - 1) ? '#95a5a6' : 'linear-gradient(135deg, #4facfe 0%, #00f2fe 100%)',
                            color: '#fff',
                            cursor: (!letterCompleted || index >= letterOrder.length - 1) ? 'not-allowed' : 'pointer',
                            boxShadow: (!letterCompleted || index >= letterOrder.length - 1) ? 'none' : '0 4px 12px rgba(79, 172, 254, 0.4)',
                            display: 'flex',
                            alignItems: 'center',
                            gap: '8px',
                            transition: 'all 0.3s ease',
                            opacity: (!letterCompleted || index >= letterOrder.length - 1) ? 0.6 : 1
                        }}
                        onMouseEnter={(e) => {
                            if (letterCompleted && index < letterOrder.length - 1) {
                                e.currentTarget.style.transform = 'translateY(-2px)';
                            }
                        }}
                        onMouseLeave={(e) => {
                            e.currentTarget.style.transform = 'translateY(0)';
                        }}
                    >
                        Next
                        <span className="material-symbols-outlined" style={{ fontSize: 20 }}>arrow_forward</span>
                    </button>
                </div>
            </div>
            <style>
                {`
          .tap-letter-board-bg {
            background: url('/image/board.png'), linear-gradient(135deg,rgba(62, 62, 62, 0.3) 0%,rgba(15, 15, 14, 0.41) 100%);
            background-size: cover, cover;
            background-position: center, center;
            border-radius: 32px;
            box-shadow: 0 6px 32px #e0c68a33;
            padding: 32px 12px 32px 12px;
            margin: 0 auto;
            max-width: 900px;
            width: 98%;
            min-height: 600px;
            display: flex;
            flex-direction: column;
            align-items: center;
            position: relative;
            z-index: 2;
            animation: board-pop 0.5s cubic-bezier(.68,-0.55,.27,1.55);
            overflow: visible;
          }
          @keyframes board-pop {
            0% { transform: scale(0.9); opacity: 0; }
            100% { transform: scale(1); opacity: 1; }
          }
          .tap-header-bar {
            width: 100%;
            display: flex;
            align-items: center;
            justify-content: space-between;
            border-radius: 20px;
            box-shadow: 0 2px 8px rgba(224,198,138,0.10);
            padding: 1px 18px 18px 18px;
            margin-bottom: 18px;
            gap: 0;
          }
          .tap-score-box,
          .tap-volume-box {
            display: flex;
            align-items: center;
            border-radius: 14px;
            padding: 6px 14px;
            font-weight: 700;
            font-size: 1.1rem;
            color: #b8860b;
            background: rgba(255, 255, 255, 0.86);
            min-width: 110px;
            box-shadow: 0 1px 4px rgba(224,198,138,0.10);
          }
          .tap-score-label {
            margin-right: 6px;
            font-size: 1rem;
            color: #b8860b;
          }
          .tap-score-value {
            font-size: 1.1rem;
            color: #1976d2;
            margin-left: 4px;
            font-weight: 700;
          }
          .tap-letter-target {
            display: flex;
            align-items: center;
            justify-content: center;
            background: rgba(224,198,138,0.92);
            border-radius: 18px;
            padding: 8px 32px;
            box-shadow: 0 1px 4px rgba(224,198,138,0.10);
            margin: 0 18px;
            min-width: 180px;
          }
          .tap-letter-label {
            font-size: 1.1rem;
            color: #3e2723;
            margin-right: 8px;
            font-weight: 600;
          }
          .tap-letter-value {
            font-size: 2rem;
            color: #1976d2;
            font-weight: 900;
            letter-spacing: 2px;
            text-shadow: 1px 1px 8px #fff, 0 0 8px #e0c68a;
          }
          .tap-volume-value {
            margin-left: 8px;
            font-size: 1rem;
            color: #1976d2;
            font-weight: 700;
            min-width: 36px;
            display: inline-block;
            text-align: right;
          }
          .score-pop {
            animation: correct-pop 0.5s;
          }
          @keyframes correct-pop {
            0% { transform: scale(1.15); }
            100% { transform: scale(1); }
          }
          @media (max-width: 1024px) {
            .tap-letter-board-bg {
              max-width: 99vw;
              padding: 18px 2vw 18px 2vw;
              min-height: 260px;
            }
          }
          @media (max-width: 700px) {
            .tap-header-bar {
              flex-direction: column;
              gap: 10px;
              padding-bottom: 10px;
            }
            .tap-letter-target {
              min-width: 0;
              width: 100%;
              padding: 8px 0;
              margin: 8px 0;
            }
            .tap-letter-board-bg {
              padding: 10px 2vw 10px 2vw;
              min-height: 180px;
            }
          }
          @media (max-width: 480px) {
            .tap-letter-board-bg {
              padding: 6px 1vw 6px 1vw;
              min-height: 120px;
            }
            .tap-header-bar {
              padding: 6px 4px 6px 4px;
            }
          }
        `}
            </style>
        </div>
    );
};

export default LetterDrawingComp;